import styled, {css} from 'styled-components'

const Tabela = styled.div`
  /* & > *, & > * > * { */
  & > * > span {
    background: ${props => props.color || "#FFF"};
    ${props => props.cursor && css`
      cursor: ${props.cursor};
    `}
  }
  div:nth-child(even) {
    filter: brightness(95%);
  }
`;

const TabelaLinha = styled.div`
  display: grid;
  grid-template-rows: minmax(22px,auto);
  justify-items: stretch;
  span:nth-child(even) {
    filter: brightness(95%);
  }
  span:nth-child(1) {
    border-right: 2px solid transparent;
  }
  &:hover {
    span:nth-child(1) {
      border-right: 2px solid blue;
    }
  }
  & > span:hover {
    filter: brightness(70%);
  }
  ${props => props.header && css`
    font-weight: bold;
    border-bottom: 1px solid black;
  `};
  ${props => props.boldFirst && css`
    span:nth-child(1) {
      font-weight: bold;
    }
  `};
  ${props => props.color && css`
    & > span {
      background: ${props.color};
    }
  `};
`;

const HideCell = styled.span`
  display: flex;
  align-items: center;
  & > * { font-size: 12px !important; }
  ${({onClick})=>onClick && `
    cursor: pointer;
  `}
`

export { HideCell, TabelaLinha };
export default Tabela;
